/**
 * Make all imported dependencies globally available by assign them into window
 */

// jQuery
import jQuery from "jquery";
// window.jQuery = jQuery;
// window.$ = jQuery;

// Bootstrap
// import popper from "popper.js";
// window.popper = popper;
// import * as bootstrap from "bootstrap";
// window.bootstrap = bootstrap;

// todo: Remove when legacy cart checkout will be refactored
// Popup modal dialogs
// import swal from 'sweetalert';
// window.swal = swal;

// Image carousel slider
import SwiperCore, { Navigation, Pagination, Autoplay, Lazy } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, Lazy]);
window.Swiper = SwiperCore;

// Ellipsis multiline text
// https://github.com/xavi160/Clamp.js
import $clamp from "clamp-js";
window.$clamp = $clamp;

// Custom scroll bar
// https://github.com/Grsmto/simplebar/tree/master/packages/simplebar
import * as SimpleBar from 'simplebar';
window.SimpleBar = SimpleBar;

// Range slider for filters
// https://github.com/leongersen/noUiSlider/
import * as noUiSlider from 'nouislider';
window.noUiSlider = noUiSlider;

// Range slider for filters
// https://github.com/leongersen/wnumb
import wNumb from 'wnumb';
window.wNumb = wNumb;

// ImageZoom
// http://github.com/jackmoore/zoom
import * as zoom from 'jquery-zoom';
window.zoom = zoom;

// jQuery form validation
import validate from 'jquery-validation';
window.validate = validate;

// Input mask
// https://robinherbots.github.io/Inputmask/
import Inputmask from "inputmask";
window.Inputmask = Inputmask;
import 'inputmask/dist/bindings/inputmask.binding.js'; // auto bind mask
